<template lang="pug">
.status-certificacao__linha
    .status-certificacao__cartao(
        v-for='(resultado, index) in dadosCertificacao.certificacaoTerritorioResultado',
        :key='index'
    )
        .status-certificacao-cartao__titulo
            h3(icon='mdi-alert-circle') {{ resultado.tipoCertificacaoCodigo }}
            el-tooltip(placement='top', :disabled='true')
                i.mdi.mdi-information-outline
        .lyra__cartao(v-loading='carregando')
            .lyra-cartao-conteudo-interno
                .status-certificacao-completo
                    .status-certificacao
                        span.status-certificacao__titulo Status da certificação
                        span.staus(
                            :class='corStatus[resultado.resultadoCodigo].classeCor'
                        ) {{ resultado.resultadoNome }}
                    .status-certificacao-informacoes
                        .status-certificacao-informacoes__inconsistencia
                            span.inconsistencia {{ resultado.numeroInconsistencias }} inconsistências encontradas
                        .status-certificacao-informacoes__detalhe-status(
                            @click='goToDetalhamentoResultadoDiagnostico(resultado)'
                        )
                            span.detalhe Detalhar
                            i.mdi.mdi-arrow-right

                .linha-separacao-status(
                    v-if='resultado.resultadoParcial !== null'
                )
                .status-certificacao-completo(
                    v-if='resultado.resultadoParcial !== null'
                )
                    .status-certificacao
                        span.status-certificacao__titulo Certificação parcial
                        span.staus(
                            :class='corStatus[resultado.resultadoParcial.resultadoCodigo].classeCor'
                        ) {{ resultado.resultadoParcial.resultadoNome }}
                    .status-certificacao-informacoes
                        .status-certificacao-informacoes__inconsistencia

                        .status-certificacao-informacoes__detalhe-status(
                            @click='goToDetalhamentoResultadoParciaDiagnostico(resultado)'
                        )
                            span.detalhe Detalhar
                            i.mdi.mdi-arrow-right
</template>

<script>
import Certificacao from '@/services/CertificacaoService.js';
import { mapActions } from 'vuex';

export default {
    name: 'BlocoStatusCertificacoes',

    props: {
        dadosCertificacao: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            carregando: false,
            corStatus: {
                ELEGIVEL: {
                    classeCor: 'status-sucess'
                },
                INELEGIVEL: {
                    classeCor: 'status-danger'
                },
                EM_ANALISE: {
                    classeCor: 'status'
                },
                NAO_ANALISADO: {
                    classeCor: 'status'
                },
                NAO_SE_APLICA: {
                    classeCor: 'status-danger'
                }
            }
        };
    },

    methods: {
        async handleMarcarElegivel(resultado, event) {
            if (event) {
                const result = await this.$messageBox.confirm(
                    this.$t('mensagens.certificacao.desejaMarcar'),
                    this.$t('mensagens.certificacao.aviso'),
                    {
                        confirmButtonText: this.$t(
                            'mensagens.certificacao.confirmar'
                        ),
                        cancelButtonText: this.$t(
                            'mensagens.certificacao.cancelar'
                        ),
                        type: 'warning'
                    }
                );
                if (result) {
                    this.marcarComoCertificado(
                        String(resultado.id),
                        this.$route.path.replace(/\D/g, '')
                    ).then(() => {
                        resultado.resultadoNome = 'Certificado';
                        resultado.resultadoCodigo = 'CERTIFICADO';
                    });
                }
            }
        },
        ...mapActions(['setCertificado']),

        statusClasseCor() {
            if (this.resultado && this.resultado.resultadoCodigo) {
                return (
                    this.corStatus[this.resultado.resultadoCodigo]?.classeCor ||
                    'default-status'
                );
            }
            return 'default-status';
        },

        async marcarComoCertificado(resultado, event) {
            try {
                await Certificacao.marcarComoCertificado(resultado, event).then(
                    res => {
                        this.$notify.success(
                            this.$t('mensagens.certificacao.sucesso')
                        );
                    }
                );
            } catch (error) {
                this.$notify.error(this.$t('mensagens.certificacao.erro'));
            }
        },

        goToDetalhamentoResultadoDiagnostico(resultado) {
            if (this.dadosCertificacao?.id && resultado?.id) {
                this.$router.push({
                    name: 'DetalhamentoResultadosDiagnosticos',
                    params: {
                        idCertificacaoTerritorio: this.dadosCertificacao.id,
                        idCertificacaoTerritorioTipo: resultado.id,
                        possuiResultadoParcial:
                            resultado.resultadoParcial !== null,
                        isRecorteElegivel: false,
                        idRouteParaCertificacoes: this.dadosCertificacao.id,
                        codigoResultado: resultado.resultadoCodigo
                    }
                });
            }
        },

        goToDetalhamentoResultadoParciaDiagnostico(resultado) {
            if (this.dadosCertificacao?.id && resultado?.id) {
                this.$router.push({
                    name: 'DetalhamentoResultadosDiagnosticos',
                    params: {
                        idCertificacaoTerritorio:
                            this.dadosCertificacao.idCertificacaoRelacionada,
                        idCertificacaoTerritorioTipo: resultado.id,
                        possuiResultadoParcial: true,
                        isRecorteElegivel: true,
                        idRouteParaCertificacoes: this.dadosCertificacao.id,
                        codigoResultado: resultado.resultadoCodigo
                    }
                });
            }
        }
    },

    mounted() {}
};
</script>

<style lang="scss" scoped>
.status-certificacao__linha {
    flex-grow: 1;
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
    gap: 20px;

    .status-certificacao__cartao {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        h3 {
            font-weight: 700;
            margin-bottom: 8px;
        }

        .status-certificacao-cartao__titulo {
            display: flex;
            gap: 5px;

            .icon {
                width: 15px;
                height: 15px;
            }
        }
    }

    .lyra__cartao {
        display: grid;
        grid-template-columns: 1fr 2fr;
        flex: 1 1 30%;
        align-items: flex-start;
        display: flex;

        flex-direction: column;
        flex: 1 1 30%;
        gap: 16px;
        padding: 16px;
        min-height: 162px;

        .lyra-cartao-conteudo-interno {
            display: flex;
            gap: 8px;
            width: 100%;
            justify-content: space-between;
            .linha-separacao-status {
                border: 1px solid #b7b7b7;
            }

            .status-certificacao-completo {
                display: flex;
                flex-direction: column;
                width: 100%;
                justify-content: space-between;
                min-height: 130px;
            }
        }

        .status-certificacao__titulo {
            font-size: 14px;
        }

        .status-certificacao {
            display: flex;
            flex-direction: column;
        }

        .status-sucess {
            font-size: 24px;
            font-weight: bold;
            color: var(--green);
        }

        .status-danger {
            font-weight: bold;
            color: var(--danger);
            font-size: 24px;
        }

        .status {
            font-weight: bold;
            font-size: 24px;
        }
        .status-certificacao-informacoes {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            flex-wrap: wrap;
            width: 100%;

            .status-certificacao-informacoes__detalhe-status {
                display: flex;
                gap: 8px;
            }

            .detalhe {
                cursor: default;
            }

            .detalhe,
            .inconsistencia {
                font-size: 12px;
            }
        }
    }
}

.status-certificacao__linha:last-child {
    margin-bottom: 0;
}

@media (max-height: 710px) {
    .status-certificacao {
        display: flex;
        flex-direction: column;
    }
}
</style>
